var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74906 14.2501V5.87261L13.4091 9.53261C13.7016 9.82511 14.1816 9.82511 14.4741 9.53261C14.7666 9.24011 14.7666 8.76761 14.4741 8.47511L9.53156 3.53261C9.23906 3.24011 8.76656 3.24011 8.47406 3.53261L3.52406 8.46761C3.23156 8.76011 3.23156 9.23261 3.52406 9.52511C3.81656 9.81761 4.28906 9.81761 4.58156 9.52511L8.24906 5.87261V14.2501C8.24906 14.6626 8.58656 15.0001 8.99906 15.0001C9.41156 15.0001 9.74906 14.6626 9.74906 14.2501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpward);
export default __webpack_public_path__ + "static/media/arrow-upward.3e3c11b898f82f44dff3c0a88e80d3a6.svg";
export { ForwardRef as ReactComponent };